import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { ComponentProps } from "react";
import { Dispatch } from "redux";
import eyeImage from "../../../common/images/eye.svg";
import checkWhiteImage from "../../../common/images/check-white.svg";
import closeWhiteImage from "../../../common/images/close-white.svg";
import editImage from "../../../common/images/edit.svg";
import refreshBlueImage from "../../../common/images/refresh-blue.svg";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { PostActionType, Refetch } from "../../../common/types/Types";
import { openFileInNewTab } from "../../../common/utils/openFileInNewTab";
import {
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../modals/EditCertificateModal/EditCertificateModalSlice";
import {
    setIsRejectCertificateModalOpen,
    setSelectedCertificate as setSelectedRejectModalCertificate,
} from "../../../modals/RejectCertificateModal/RejectCertificateModalSlice";
import { handleReview } from "./handleReview";

type DetailCardAction = NonNullable<
    ComponentProps<typeof DetailCard>["actions"]
>[number];

interface Props {
    certificate: CertificateInterface;
    dispatch: Dispatch;
    patchCertificate: PostActionType;
    refetch: Refetch;
    isAcceptLoading: boolean;
    isEditLoading: boolean;
}

export const getReviewCardActionData = (props: Props): DetailCardAction[] => {
    const {
        certificate,
        dispatch,
        patchCertificate,
        refetch,
        isAcceptLoading,
        isEditLoading,
    } = props;

    const actions: DetailCardAction[] = [];

    if (certificate.certificate_file.file_url) {
        actions.push({
            type: "link",
            icon: eyeImage,
            label: "Bekijken",
            onClick: () => {
                void openFileInNewTab(certificate.certificate_file.file_url);
            },
        });
    }

    actions.push(
        {
            type: "icon-button",
            icon: checkWhiteImage,
            backgroundColor: "#afce55",
            isLoading: isAcceptLoading,
            onClick: () => {
                void handleReview({
                    certificate,
                    patchCertificate,
                    refetch,
                    review: true,
                    dispatch,
                });
            },
        },
        {
            type: "icon-button",
            icon: closeWhiteImage,
            backgroundColor: "#e33f3f",
            onClick: () => {
                dispatch(setIsRejectCertificateModalOpen(true));
                dispatch(setSelectedRejectModalCertificate(certificate));
            },
        },
        {
            type: "icon-button",
            icon: editImage,
            backgroundColor: "#F3F4F6",
            isLoading: isEditLoading,
            loadingIcon: refreshBlueImage,
            onClick: () => {
                dispatch(setSelectedCertificateId(certificate.id));
                dispatch(setIsEditCertificateModalOpen(true));
            },
        },
    );

    return actions;
};
